export default "__VITE_ASSET__DooIzqAb__"